import { Star, Quote } from "lucide-react";

const TESTIMONIALS = [
  {
    name: "Cheryl Bambrough",
    initial: "C",
    color: "#2BB8B4",
    rating: 5,
    text: "First visit was great. Analysis of my feet health helped too. Would recommend definitely.",
  },
  {
    name: "Steven Black",
    initial: "S",
    color: "#7B46D9",
    rating: 5,
    text: "Fantastic service. I got my mum a same day appointment after calling. Would highly recommend.",
  },
  {
    name: "Kirsteen Anderson",
    initial: "K",
    color: "#C87961",
    rating: 5,
    text: "Great care was given. Full explanations also provided.",
  },
  {
    name: "Rob",
    initial: "R",
    color: "#5FE6E0",
    rating: 5,
    text: "Fantastic service, full treatment, really gentle and lovely person — will defo use again.",
  },
  {
    name: "Samantha Mckay",
    initial: "S",
    color: "#A3B899",
    rating: 5,
    text:
      "Dr Reddy came out today for assessment and MOT. I have suffered for well over a year with ingrown toenails on both big toes. Today I can breathe easy as I'm not in pain. He is so patient and put me at ease — I cannot speak highly enough about his professionalism and bedside manner.",
  },
  {
    name: "Mosco Moon",
    initial: "M",
    color: "#2BB8B4",
    rating: 5,
    text:
      "Arranged an appointment for my gran. Her toenails were long, curled and painful. Dr Reddy was kind, patient and managed to restore my grandmother's feet in just one visit. Honestly amazing work — she really enjoyed the experience, which I didn't expect as she gets nervous around strangers. 10/10 would recommend!",
  },
  {
    name: "Megan",
    initial: "M",
    color: "#7B46D9",
    rating: 5,
    text:
      "My mother phoned Litisha on Thursday and an appointment was arranged for Saturday! Reddy arrived punctually and did a very extensive examination, followed by very careful and thorough treatment. She will definitely be arranging visits from Reddy in future.",
  },
  {
    name: "Viresh Panday",
    initial: "V",
    color: "#C87961",
    rating: 5,
    text:
      "Contacted Litisha Foot Care on a Saturday morning with an extremely sore ingrown toenail. Mr Reddy booked me in for the same afternoon — punctual, very professional and the pain was minimal. Felt relief immediately. Highly recommended.",
  },
  {
    name: "Fiona Wheater",
    initial: "F",
    color: "#5FE6E0",
    rating: 5,
    text:
      "Reddy was very professional and helped take away the pain of my toenail. He cut all my nails, removed the hard skin and gave me a foot health assessment. I've booked another appointment for ongoing treatment. Very happy with the service.",
  },
  {
    name: "Lynne S",
    initial: "L",
    color: "#A3B899",
    rating: 5,
    text:
      "Fantastic service! Reddy came out to my house to help with pain in my feet. He was very kind, I felt comfortable having him in my house, and he was very professional and knowledgeable. Sent useful links and information afterwards. Highly recommend — good price too!",
  },
  {
    name: "Thomas Brannan",
    initial: "T",
    color: "#2BB8B4",
    rating: 5,
    text:
      "Great advice on foot maintenance. Always let me know what he was going to do next. Very friendly and I would recommend this company for all your foot care.",
  },
  {
    name: "Jennifer Tait",
    initial: "J",
    color: "#7B46D9",
    rating: 5,
    text: "Helped my grandmother with her foot health when she could no longer go out — it's much appreciated!",
  },
  {
    name: "Paula Yuill",
    initial: "P",
    color: "#C87961",
    rating: 5,
    text:
      "My husband needed help with his toenails. An appointment was arranged very quickly. Very helpful, attended on time and very thorough — explained the issue, how to resolve it and arranged the next appointment before leaving. A follow-up email was sent explaining everything. Very professional and will definitely use again. Very handy they come to your house!",
  },
  {
    name: "John Howard",
    initial: "J",
    color: "#5FE6E0",
    rating: 5,
    text:
      "Reddy is a skilled Foot Health Practitioner who does home visits — I would highly recommend. Reddy was able to see me at short notice and kept me informed throughout the treatment.",
  },
  {
    name: "Gillian Davidson",
    initial: "G",
    color: "#A3B899",
    rating: 5,
    text:
      "Mr Reddy was very professional and gave me good advice and treatment. He sent info on my toe condition and treatment which I had not been advised about before.",
  },
];

export default function Testimonials() {
  // Duplicate the list so the marquee loops seamlessly
  const loop = [...TESTIMONIALS, ...TESTIMONIALS];

  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="lfc-section relative overflow-hidden"
    >
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-[#4A2D7A] to-transparent" />
      <div className="absolute top-1/3 left-1/3 w-[420px] h-[420px] rounded-full bg-[#2BB8B4]/8 blur-[120px] pointer-events-none" />

      <div className="lfc-container relative">
        <div className="max-w-3xl">
          <div className="lfc-eyebrow mb-4">What patients say</div>
          <h2 className="lfc-h2">
            Trusted by patients across <br className="hidden md:block" />
            central Scotland.
          </h2>
          <p className="mt-5 text-lg text-[#C2B4E6] leading-relaxed">
            Real reviews from real patients — kindness, professionalism and a focus on your comfort
            are at the heart of everything we do.
          </p>
          <div className="lfc-divider-leaf mt-7" />
        </div>
      </div>

      {/* Full-bleed marquee */}
      <div className="mt-14 lfc-marquee-mask">
        <div className="lfc-marquee" data-testid="testimonials-marquee">
          {loop.map((t, i) => (
            <TestimonialCard key={`${t.name}-${i}`} t={t} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}

function TestimonialCard({ t, index }) {
  return (
    <article
      data-testid={`testimonial-${index}`}
      className="lfc-card p-7 lg:p-8 w-[340px] md:w-[400px] shrink-0 flex flex-col"
    >
      <div className="flex items-start justify-between gap-4">
        <div className="flex items-center gap-3">
          <div
            className="w-12 h-12 rounded-full grid place-items-center text-white font-semibold text-lg shrink-0"
            style={{ backgroundColor: t.color, fontFamily: "Outfit" }}
          >
            {t.initial}
          </div>
          <div className="leading-tight">
            <div className="text-[15px] font-semibold text-white" style={{ fontFamily: "Outfit" }}>
              {t.name}
            </div>
            <div className="mt-1.5 flex items-center gap-1">
              {Array.from({ length: t.rating }).map((_, i) => (
                <Star
                  key={i}
                  className="w-3.5 h-3.5 text-[#FFB44A]"
                  fill="#FFB44A"
                  strokeWidth={0}
                />
              ))}
            </div>
          </div>
        </div>
        <Quote className="w-5 h-5 text-[#2BB8B4]/60 shrink-0" strokeWidth={1.6} />
      </div>

      <p className="mt-5 text-[15px] text-[#E5DEFA] leading-relaxed flex-1">
        “{t.text}”
      </p>
    </article>
  );
}
